exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn[data-v-232e41f6] {\n  margin-right: 16px;\n}\n", ""]);

// exports
